import React from 'react';
import Horizon from './Horizon';

const Footer = () => {
  return (
    <footer className="footer">
      <Horizon />
      <div className="footer-ground">
        <div className="footer-content">
        <p>Built for thoughtful systems and the people who make them work.</p>
        <div className="footer-links">
          <a href="https://linkedin.com/in/timcrider" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="mailto:timcrider@gmail.com">Email</a>
          <a href="https://github.com/timcrider" target="_blank" rel="noopener noreferrer">GitHub</a>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;